import Modal from '../modal';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

const EvChargerBanner = () => {
  const openModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, `ev-charger-modal`);
  const closeModal = () => EventEmitter.emit(EVENT_TYPES.closeModal);

  return (
    <>
      <div className="ac-promo ac-promo--ev-charger ch-flex-direction--column sm:ch-flex-direction--row">
        <p className="ac-promo__title ch-fw--500 ch-text--center sm:ch-text--left sm:ch-mb--0">
          Get a home charger for only £549 when you buy this car!
        </p>
        <button
          className="ac-promo__link ch-color--ac-black ch-fw--500 sm:ch-fs--3 sm:ch-ml--2 ch-btn ch-btn--link ch-pa--0"
          onClick={openModal}
          type="button"
        >
          Find out more
        </button>
      </div>
      <Modal hideClose id="ev-charger-modal">
        <div className="ch-modal ch-modal--xs ev-charger-modal">
          <div className="ev-charger-modal__header">
            <button
              className="ch-modal__close"
              onClick={closeModal}
              type="button"
            >
              <span className="ch-reader">Close</span>
            </button>
          </div>
          <div className="ch-text--center ch-pa--3 ch-bg--white">
            <p className="ch-fs--4 ch-fw--600">
              Buy a fully electric used car and get a Bumblebee Point home
              charger for only £549.
            </p>
            <p className="ch-lh--body">
              After your purchase, our trusted partner Bumblebee will contact
              you to arrange your included installation.
            </p>
            <a
              className="ch-btn ch-btn--primary ch-btn--sm ch-width--12 sl:ch-width--auto ch-mb--2"
              href="/vehicles?features%5B%5D=Discounted+home+charger"
              rel="nofollow"
            >
              Shop electric cars
            </a>
            <div>
              <a href="/terms" rel="nofollow">
                View terms and conditions
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EvChargerBanner;
